import { addEvent } from "@stikipixels/analytics-browser";

export default function search(query) {
  addEvent({ type: "search", payload: { query } });
}
